export default __webpack_public_path__ + "static/media/hangman.a2413e22.png";